const state = {
  id: null,
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
